import { DdpImage } from "@/components/shared/DdpImage";
import { TDdpMedia } from "@/shared/types";

export function EighthSection(props: Array<{
    text: string
    imageOnTheRight: Array<TDdpMedia>
}>) {
    const { text, imageOnTheRight } = props[0];
    return (
        <div className="landing-eighth-section">
            <div className="image-on-the-right">
                <DdpImage image={imageOnTheRight[0]} />
            </div>
            <div className="text">{text}</div>
        </div>
    );
}